import React from "react";

const Loading = () => {
  return (
    <div className="loading">
      <div className="loading_icon" />
    </div>
  );
};

export default Loading;
